/**
 * Avatar URL handling for the shell's three `user.avatar` render sites
 * (header, mini-sidebar, expanded side menu).
 *
 * `user_details.avatar` arrives from the API either as an absolute URL (S3/CDN
 * or a social-login provider) or as a bare storage path. A bare path with no
 * leading slash is resolved by the browser *relative to the current route*, so
 * the very same avatar that loads on `/flyboard` 404s on a deep-linked
 * `/persona/:id` — the shell mounts once, the binding is never re-evaluated,
 * and the broken image sticks for the rest of the session. Anchoring relative
 * paths at the origin makes the URL route-independent.
 */
export function normalizeAvatarUrl(avatar: string | null | undefined): string {
  const url = (avatar ?? "").trim();

  if (!url) {
    return "";
  }

  // Absolute / protocol-relative / data URI / already root-anchored.
  if (/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(url) || url.startsWith("/")) {
    return url;
  }

  return `/${url}`;
}
